import { jsx as _jsx } from "react/jsx-runtime";
/** Visually hidden is a type of **atom** that represents a invisible, but accessible span element. */
const VisuallyHidden = ({ children }) => {
    return _jsx("span", { className: "sr-only", children: children });
};
export default VisuallyHidden;
//# sourceMappingURL=VisuallyHidden.js.map